
const defaultProp = {
  outlined: true,
  class: "mt-2 caption",
  dense: true,
  "background-color": "white",
};
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../../mixins/ActionMixin";
import { Action } from "vuex-class";
import { Prop } from "vue-property-decorator";
@Component
export default class BaseAutocompleteEvent extends mixins(ActionMixin) {
  @Action("profile/requestAllEvents") requestAllEvents: any;
  @Prop({ default: [] }) events: Array<Event>;
  items: any[] = [];
  loading = false;
  filter = "";
  get defaultConfigs(): any {
    return {
      ...this.$attrs,
      ...this.$props,
      ...defaultProp,
    };
  }
  created(): void {
    this.updateMentionList();
  }
  async updateMentionList(): Promise<void> {
    this.loading = true;
    if (this.events.length === 0) {
      await this.withLoading(async () => {
        await this.requestAllEvents()
          .then((data: any) => {
            this.items = data;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    } else {
      this.items = this.events;
      this.loading = false;
    }
  }
  resetFilter(): void {
    this.filter = "";
  }
}
